import React from 'react'
import TabsDemo from '../demos/tabs/TabsDemo'

const TabsContainer = () => {
  return (
    <div className='tabs-demo mt-30'>
      <TabsDemo />
    </div>
  )
}

export default TabsContainer
